module.exports = __webpack_public_path__ + "static/bg5.a9600bec.jpg";